var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 36V24a16 16 0 1132 0v12h2v4H1v-4h2zm4 0h24V24a12 12 0 00-24 0v12zM17 0h4v6h-4V0zm17.556 5.616l2.828 2.828-4.24 4.242-2.83-2.828 4.242-4.242zM.616 8.444l2.828-2.828 4.242 4.24-2.826 2.832L.616 8.444zM9 24a10 10 0 0110-10v4a6 6 0 00-6 6H9z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/svg/alert.svg";
export { SvgAlert as ReactComponent };